<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g id="icon">
      <path
        d="M3.5,8.5h14v9c0,0.55,-0.45,1,-1,1h-12c-0.55,0,-1,-0.45,-1,-1v-9z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5,4.5c0,-0.55,0.45,-1,1,-1h14c0.55,0,1,0.45,1,1v4h-16v-4z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="10.5"
        y1="11"
        x2="10.5"
        y2="15"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
      />
      <polyline
        points="8.5,13.5 10.5,15.5 12.5,13.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
